import { Modal, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";

const SEConfirmModal = ({
  opened,
  onClose,
  onConfirm,
  message,
  confirmLabel,
  cancelLabel,
  showCancel = true,
  header,
  confirmColor = "#3dcd58",
  cancelColor = "red",
  onlyOk = false,
  confirmDisabled = false,
  confirmLoading = false,
  confirmLoadingLabel,
  size,
  modalPadding
}) => {
  const { t } = useTranslation();
  const effectiveMessage = message ?? t("common.confirmMessage");
  const effectiveConfirmLabel = confirmLabel ?? t("common.yes");
  const effectiveCancelLabel = cancelLabel ?? t("common.no");
  const effectiveHeader = header ?? t("common.alert");
  return (
  <Modal
    opened={opened}
    onClose={onClose}
    title={null}
    centered
    withCloseButton={false}
    styles={{ header: { padding: modalPadding ?? 0, margin: 0 } }}
    closeOnClickOutside={onlyOk ? false : true}
    {...(size ? { size } : {})}
  >
    <div
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: 56,
        background: '#3dcd58',
        color: '#fff',
        borderRadius: '6px 6px 0 0',
        fontWeight: 600,
        fontSize: 20,
        display: 'flex',
        alignItems: 'center',
        paddingLeft: '3%',
        zIndex: 2,
      }}
    >
      {effectiveHeader}
    </div>
    <div style={{ height: 56 }} />
    {typeof effectiveMessage === 'string' ? (
      <Text mb="md" dangerouslySetInnerHTML={{ __html: effectiveMessage }} />
    ) : (
      <div style={{ marginBottom: '1rem' }}>{effectiveMessage}</div>
    )}
    <div style={{ display: "flex", justifyContent: "flex-end", gap: "1rem" }}>
      {onlyOk ? (
        <se-button aria-label="confirm-modal-ok" option="raised" color="standard" onClick={onClose}>{t("common.ok")}</se-button>
      ) : (
        <>
          <se-button
            aria-label="confirm-modal-confirm"
            option="flat"
            color="primary"
            onClick={onConfirm}
            disabled={confirmDisabled || confirmLoading}
          >
            {confirmLoading
              ? (confirmLoadingLabel
                  ? confirmLoadingLabel
                  : <se-loading loading={true} style={{ height: '20px' }} />)
              : effectiveConfirmLabel}
          </se-button>
          {showCancel && (
            <se-button
              aria-label="confirm-modal-cancel"
              color="standard"
              // option="outline"
              onClick={onClose}
            >
              {effectiveCancelLabel}
            </se-button>
          )}
        </>
      )}
    </div>
  </Modal>
  );
};

export default SEConfirmModal;
